import React from 'react'
import styles from './styles.css'
import { Form, Field } from 'simple-react-form'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import { withRouter } from 'react-router'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import VerifyAlert from 'App/components/VerifyAlert'
import isAdmin from 'App/Decorators/isAdmin'
import FeaSigners from '../../../../components/fields/FeaSigners'
import FileBinary from 'react-icons/lib/go/file-binary'

@isAdmin
@withGraphQL(
  gql`
    query getMyPendingDocuments {
      me {
        _id
        emails {
          address
        }
      }
    }
  `
)
@withMutation(gql`
  mutation updateFeaSigners(
    $documentId: ID
    $feaSigners: [FeaSignerInput]
    $organizationId: ID
  ) {
    updateFeaSigners(
      documentId: $documentId
      feaSigners: $feaSigners
      organizationId: $organizationId
    ) {
      _id
      signatureRequested
      feaSigners {
        id
        name
        email
      }
    }
  }
`)

@withRouter
@withMessage
export default class UpdateFea extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    document: PropTypes.object,
    updateFeaSigners: PropTypes.func,
    me: PropTypes.func,
    organization: PropTypes.object,
    admin: PropTypes.string,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  static fragment = gql`
    fragment documentUpdateInformation on Document {
      name
      description
      fromTemplate
    }
  `

  state = {}

  renderAlert() {
    return <VerifyAlert onClick={() => this.sendEmail()} ref="alert" />
  }



  // Send email to the users
  @autobind
  async save({ feaSigners }) {
    console.log("updateFeaSigners SAVE", feaSigners);
    this.setState({ loading: true })
    try {
      if(feaSigners){
        feaSigners.forEach(feaSigner => {
          console.log("Objeto a modificar", feaSigner);
          feaSigners.signData = undefined;
        });
      }
      console.log("feaSigners para update: ", feaSigners);
      await this.props.updateFeaSigners(
        {
          documentId: this.props.document._id,
          feaSigners,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Success')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  changeForm(state) {
    console.log("pre changeForme", state);
    console.log("==========> changeForm setState");
    this.setState(state)
    console.log("post changeForme", state);
  }

  buttonsAppear() {
    if (
      (!this.props.url && this.props.document.documentOwner) ||
      (this.props.organization && this.props.organization.myRole === 'owner')
    ) {
      return true
    }
    return false
  }

  renderFeaSigners() {
    return (
      <div className={styles.container}>
        <Form
          ref={form => {
            this.form = form
          }}
          state={this.props.document}
          onSubmit={this.save}
          onChange={state => this.changeForm(state)}
        >
          <div className="section">
            <div className="header">
              <div className="row">
                <div className="col-xs-12 col-sm-10">
                  <h3 className={styles.title}>Firmas Electrónicas Avanzadas. Puedes cambiar el orden de los Firmates arrastando a la nueva posición</h3>
                </div>
                <div className="col-xs-12 col-sm-2 end-md">
                  <div className={styles.icon}>
                    <FileBinary size={20} />
                  </div>
                </div>
              </div>
            </div>
            <div className="content">
              <Field
                fieldName="feaSigners"
                draggable={true}
                type={FeaSigners}
                autoAdd={false}
                url={this.props.url}
                owner={this.props.document.documentOwner}
                organization={this.props.organization}
              />

              {this.buttonsAppear() ? (
                <div>
                  <br />
                  <Button
                    primary
                    loading={this.state.loading}
                    onClick={() => this.form.submit()}
                  >
                    Guardar
                  </Button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </Form>
      </div>
    )
  }

  render() {
    return this.renderFeaSigners()
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/UpdateFea/index.js